<template>
	<div>
        <!-- Info Modal -->
        <div id="info-modal" class="uk-flex-top" uk-modal>
            <div class="uk-modal-dialog">
                <button class="uk-modal-close-default" type="button" uk-close></button>
                <div class="uk-modal-header">
                    <h2>{{ info.title }}</h2>
                </div>
                <div class="uk-modal-body uk-overflow-auto" v-html="info.content">
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import {mapState} from 'vuex';
	export default {
		name : "info-modal",
		components: {},
        computed : {
            ...mapState({
                info : state => state.current_info_data 
            })
        }
	}
</script>